const getSortValue = (value: any, key: string) => {
  const split = key.split('.');

  let result = value[split[0]];
  if (!result) {
    return null;
  }
  for (let i = 1; i < split.length; i++) {
    result = result[split[i]];
  }
  return result;
};

export const simpleSort = (data: any[], sort: { by?: string | null; direction?: 'asc' | 'desc' }) => {
  if (!sort.by) return data;
  else {
    const sorted = [...data].sort((a: any, b: any) => {
      let valueA = getSortValue(a, sort.by!);
      let valueB = getSortValue(b, sort.by!);
      if (!valueA && valueA !== 0) return 1;
      if (!valueB && valueB !== 0) return -1;
      if (typeof valueA === 'string') return valueA.localeCompare(valueB);
      if (typeof valueA === 'number') return valueB - valueA;
      return valueA - valueB;
    });
    return sort.direction === 'desc' ? sorted.reverse() : sorted;
  }
};

export const isObject = (item: any) => item && typeof item === 'object' && !Array.isArray(item);

export const mergeDeep: any = (target: any, ...sources: any) => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) target[key] = {}; // Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        target[key] = source[key];
        // Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
};
